export type Environment = "production" | "staging" | "local";

const ENVIRONMENTS: Record<Environment, { apiUrl: string; appUrl: string }> = {
  production: {
    apiUrl: "https://api.dibretto.com",
    appUrl: "https://app.dibretto.com",
  },
  staging: {
    apiUrl: "https://api-staging.dibretto.com",
    appUrl: "https://app-staging.dibretto.com",
  },
  local: {
    apiUrl: import.meta.env.VITE_DIBRETTO_API_URL || "https://api.dibretto.test",
    appUrl: import.meta.env.VITE_DIBRETTO_APP_URL || "https://app.dibretto.test",
  },
};

const ENV_STORAGE_KEY = "dibretto_env";
const DEFAULT_ENV: Environment = import.meta.env.DEV ? "local" : "production";

export function getActiveEnvironment(): Environment {
  try {
    const stored = localStorage.getItem(ENV_STORAGE_KEY) as Environment | null;
    if (stored && stored in ENVIRONMENTS) return stored;
  } catch {
    // localStorage not available
  }
  return DEFAULT_ENV;
}

export function setActiveEnvironment(env: Environment): void {
  localStorage.setItem(ENV_STORAGE_KEY, env);
  window.location.reload();
}

export const config = {
  get apiUrl() {
    return ENVIRONMENTS[getActiveEnvironment()].apiUrl;
  },
  get appUrl() {
    return ENVIRONMENTS[getActiveEnvironment()].appUrl;
  },
};
